import { formatBooleanValue } from "../../util";
import IndexType from "../model/IndexType";

const IndexTypeMapper = (item: any) => {
  let indexType = IndexType(item);
  indexType.valid = formatBooleanValue(item.valid);
  return indexType;
};

export default IndexTypeMapper;
